'use client';

import { ROUTES } from '@shared/utils';
import { useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { useCheckoutSubmittedTicket } from '../../hooks/useCheckoutSubmittedTicket';
import type { CheckoutPurchaseConfirmation } from '../../types';

function useCheckoutPurchaseConfirmation() {
  const router = useRouter();
  const { getCheckoutSubmittedTicket, clearCheckoutSubmittedTicket } = useCheckoutSubmittedTicket();
  const [purchaseConfirmation, setPurchaseConfirmation] = useState<CheckoutPurchaseConfirmation | null>(null);
  const hasConsumedStorage = useRef(false);
  const purchaseConfirmationRef = useRef<CheckoutPurchaseConfirmation | null>(null);

  useEffect(() => {
    if (!hasConsumedStorage.current) {
      hasConsumedStorage.current = true;
      const storedConfirmation = getCheckoutSubmittedTicket() ?? null;

      if (storedConfirmation) {
        clearCheckoutSubmittedTicket();
        purchaseConfirmationRef.current = storedConfirmation;
      }
    }

    if (purchaseConfirmationRef.current) {
      setPurchaseConfirmation(purchaseConfirmationRef.current);
    } else {
      router.replace(ROUTES.HOME);
    }

    return () => {
      clearCheckoutSubmittedTicket();
    };
  }, [router, clearCheckoutSubmittedTicket, getCheckoutSubmittedTicket]);

  return { purchaseConfirmation };
}

export { useCheckoutPurchaseConfirmation };
